import { TypedDocumentNode, gql } from '@apollo/client';
import { CompanyUsers } from './getCompanyUsersById';

export type OrderCompaniesVariables = {
  company_id: number;
};

export type OrderCompanies = {
  orders_companies_by_pk: {
    company_users: CompanyUsers;
  };
};

export const getCompanyUbosQuery = gql`
  query getCompanyUbos($company_id: bigint!) {
    orders_companies_by_pk(id: $company_id) {
      id
      company_users(where: { is_ubo: { _eq: true } }) {
        id
        name
        email
        identity_verified
      }
    }
  }
` as TypedDocumentNode<OrderCompanies, OrderCompaniesVariables>;
